/* DomPickerRenderer.js */

"use strict";
const ComboBoxControl = require("@gluenetworks/combobox").Single;
const InputNumberControl = require("@gluenetworks/input_number_control");
const BaseScheduleRenderer = require("../../base/BaseScheduleRenderer");
const RendererUtils = require("../../base/RendererUtils");
const MoyComponent = require("../../common_components/moy_picker_component/MoyPickerComponent");

class DomPickerRenderer extends BaseScheduleRenderer {
    constructor(model) {
        super(model);
    }
    render(formContainerElem) {
        if (this.isRendered()) {
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(() => {
                this._firstLastDateComp = new ComboBoxControl({
                    showFilter: false,
                    options: [
                        {label: "the first day", value: 1},
                        {label: "the last day", value: 0},
                        {label: "day", value: 99},
                    ],
                    adjustWidth: true,
                });
                this._dateOfMonthComp = new InputNumberControl({value: 2, min: 2, max: 30});
                this._moyComp = new MoyComponent(this._model);

                let includeMoy = this._model.getSchedule().type === "domoy";
                this._parts = RendererUtils.groupGridRowElements(
                    formContainerElem,
                    "on",
                    "On",
                    this._firstLastDateComp,
                    this._dateOfMonthComp,
                    includeMoy ? "of" : "of the month",
                    includeMoy ? this._moyComp : null
                );

                return Promise.all([
                    this._firstLastDateComp.renderer.render(),
                    this._dateOfMonthComp.renderer.render(),
                    this._moyComp.renderer.render(),
                ]);
            })
            .then(() => {
                this._setTheme(this._model.theme);
                this._registerListeners();
                this.setRendered(true);
            });
    }
    getParts() {
        return this._parts;
    }
    shutdown() {
        if (!this.isRendered()) {
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(() => {
                this._unregisterListeners();
                return Promise.all([
                    super.shutdown(),
                    this._firstLastDateComp.shutdown(),
                    this._dateOfMonthComp.shutdown(),
                    this._moyComp.shutdown(),
                ]);
            })
            .then(() => {
                this._firstLastDateComp = undefined;
                this._dateOfMonthComp = undefined;
                this._moyComp = undefined;
                this._parts = undefined;
            })
            .catch((err) => {
                console.error(err);
            });
    }
    _registerListeners() {
        super._registerListeners();
        this._firstLastDateComp.on(
            "UserValue",
            (this._onFirstLastOther = this._onFirstLastOther.bind(this))
        );
        this._dateOfMonthComp.on("UserValue", (this._onOther = this._onOther.bind(this)));
    }
    _unregisterListeners() {
        super._unregisterListeners();
        this._firstLastDateComp.removeListener("UserValue", this._onFirstLastOther);
        this._dateOfMonthComp.removeListener("UserValue", this._onOther);
    }
    _onFirstLastOther() {
        let fistLastOther = this._firstLastDateComp.getValue();
        let dom = fistLastOther < 2 ? fistLastOther : this._dateOfMonthComp.getValue();
        this._model.setScheduleProp("dom", dom, true);
        RendererUtils.setElementsVisibility(dom >= 2, this._dateOfMonthComp);
    }
    _onOther() {
        this._model.setScheduleProp("dom", this._dateOfMonthComp.getValue(), true);
    }
    _setControlValuesFromModel() {
        let dom = this._model.getSchedule().dom;
        this._firstLastDateComp.setValue(dom < 2 ? dom : 99);
        this._dateOfMonthComp.setValue(dom > 2 && dom <= 30 ? dom : 2);
        RendererUtils.setElementsVisibility(dom >= 2, this._dateOfMonthComp);
    }
}
module.exports = DomPickerRenderer;
